import { communicationsApi } from '@app/services'

import { SendMessageRequest, SendMessageResponse } from './types'

export const sendMessage = async (request: SendMessageRequest) => {
  const { data } = await communicationsApi.post<SendMessageResponse>(
    `/chat/${request.convId}/send`,
    request.message,
    {
      headers: {
        'X-ACS-ParticipantId': request.identity,
        'X-ACS-Token': request.token,
      },
    }
  )

  return data.message
}
